import { defineComponent as l, createBlock as n, openBlock as t, unref as a, mergeProps as i, withCtx as s, createElementVNode as c } from "vue";
import { RevIcon as p } from "@ds/components/Icon";
const f = /* @__PURE__ */ l({
  name: "IconCrossInCircleFilled",
  __name: "IconCrossInCircleFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (d, e) => (t(), n(a(p), i(r, { "view-box": "0 0 24 24" }), {
      default: s(() => [...e[0] || (e[0] = [
        c("path", {
          "fill-rule": "evenodd",
          d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12m6.28-4.53a.75.75 0 0 0-1.06 1.06L10.94 12l-3.47 3.47a.75.75 0 1 0 1.06 1.06L12 13.06l3.47 3.47a.75.75 0 1 0 1.06-1.06L13.06 12l3.47-3.47a.75.75 0 0 0-1.06-1.06L12 10.94 8.53 7.47",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
